import * as types from '../types';

export const setMap = () => {
    return { type: types.TOGGLE_MAP };
};
